/**
 * Agent slug → human display.
 *
 * Two voices for one identity, deliberate per surface:
 *   - `prettyAgentTitle` — Title Case With Spaces (Top bar, sheets, lists).
 *     The chrome calls the agent by name, properly capitalized.
 *   - `prettyAgentMono` — lowercase with spaces (mono captions on bubbles
 *     and chips). Reads as a label, not a name.
 *
 * Centralized so a future scrub does not "harmonize" them; the typographic
 * register IS the difference, not a bug.
 */

export function prettyAgentTitle(slug: string): string {
  return slug
    .split('_')
    .map((p) => (p.length === 0 ? p : p.charAt(0).toUpperCase() + p.slice(1)))
    .join(' ');
}

export function prettyAgentMono(slug: string): string {
  return slug.replace(/_/g, ' ');
}
